import React from 'react';
import type { JSX } from 'react';
import { DialogManager } from '../fasades/dialogmanager';

export class DialogContainer extends React.Component 
{
    component : JSX.Element | undefined;

    constructor(props : object) {
        super(props);
        DialogManager.init(this);
    }

    closeModal() {
        this.component = undefined;
        this.forceUpdate();
    };

    openModal(component : JSX.Element) {
        this.component = component;
        this.forceUpdate();
    };

    render() {
        let comp = this.component;

        return (
          <>
            {comp !== undefined && comp }
          </>
        );
    };
};

